<template>
    <div class="c-countryBanner-layout" v-if="isActive">
        <span id="countryBanner-glyphicon" class="glyphicon glyphicon-remove-circle c-modelClose-icon" @click="() => closeWindow(this.shopCountryCode)"></span>
        <p class="c-model-text" v-html="informationText"></p>
        <span class="c-modelBtn">
            <a id="countryBanner-current-shop" class="c-modelBtn-default" v-html="lang.current_shop[this.shopCountryCode]" @click="() => closeWindow(this.shopCountryCode)"></a>
            <a id="countryBanner-btn-detected-shop" class="c-modelBtn-other" v-bind:href="this.lang.detected_shop_link[this.detectedCountryCode]" v-if="this.lang.detected_shop[this.detectedCountryCode]" v-html="this.lang.detected_shop[this.detectedCountryCode]" @click="() => closeWindow(this.detectedCountryCode)"></a>
        </span>
    </div>
</template>

<script>
import * as Cookies from "js-cookie";
import axios from 'axios';

const cookieName = 'prefered-shop';
const cookieExpiryDays = 180;

export default {
    name: "CountryBanner",
    props: [],
    data: function () {
        return {
            isActive: false,
            lang: {},
            detectedCountryCode: 'DE',
            shopCountryCode: window.locale.split('-')[1].toUpperCase()
        }
    },
    methods: {
        closeWindow: function (countryCode) {
            Cookies.set(cookieName, countryCode, {expires: cookieExpiryDays, domain: window.location.hostname, SameSite: 'None', secure: true});
            this.isActive = false;
        },
        hasDivergingLocation: function () {
            return this.shopCountryCode !== this.detectedCountryCode;
        },
        isPreferedShop: function () {
            return Cookies.get(cookieName) === this.shopCountryCode;
        }
    },
    created: function () {
        const browserLang = navigator.language.toLowerCase();
        let lang = '';
        if (browserLang.startsWith('de')) {
            lang = 'de-de';
        } else if (browserLang.endsWith('at')) {
            lang = 'de-at';
        } else if (browserLang.startsWith('fr')) {
            lang = 'fr-fr';
        } else {
            lang = 'en-us';
        }
        axios.get('/' + lang + '/getCountryBannerText')
            .then(response => {
                this.lang = response.data.texts;
                let ipAddessData = response.data.ipAddressData
                this.detectedCountryCode = ipAddessData.countryCode ? ipAddessData.countryCode.toUpperCase() : 'DE';
                this.isActive = !this.isPreferedShop() && this.hasDivergingLocation();
            });
    },
    computed: {
        informationText: function () {
            return this.lang.information_text[this.detectedCountryCode] || this.lang.information_text.default;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../css/variables.scss";

.c-countryBanner-layout {
    position: fixed;
    height: 110px;
    width: 290px;
    border-radius: 5px;
    background-color: $color-jungle-green;
    right: 140px;
    bottom: 54px;
    padding: 10px 25px 10px 10px;
    color: white;
    font-size: 12px;
    z-index: 1000;

    @media (max-width: 648px) {
        right: 90px;
        bottom: 10px;
        width: 245px;
        height: 125px;
    }
}

.c-modelClose-icon {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    font-size: 18px;
    padding: 5px;
}

.c-model-text {
    font-size: 12px;
}

.c-modelBtn {
    display: flex;
    justify-content: flex-start;
    column-gap: 30px;
    width: 100%;

    @media (max-width: 648px) {
        column-gap: 10px;
    }

    a {
        border-radius: 5px;
        width: 40%;
        text-align: center;
        cursor: pointer;

        @media (max-width: 648px) {
            width: 50%;
        }
    }

    .c-modelBtn-default {
        background-color: $color-lime-yellow;
        color: $color-jungle-green;
        border: 1px solid $color-lime-yellow;
    }

    .c-modelBtn-other {
        background-color: $color-jungle-green;
        color: $color-white;
        border: 1px solid $color-white;
    }
}
</style>
